module.exports = __webpack_public_path__ + "static/media/PDF_99.dbdaa12c.pdf";